"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const ObjectReviewButtons_1 = __importDefault(require("./ObjectReviewButtons"));
/**
 * Connected approve/reject/force-approve controls for one survey object.
 * Receives review state from the parent so reviewability is decided once upstream.
 * @param props - Review state, object type, and uuid
 * @returns Review buttons, or null when the object is not reviewable
 */
const ObjectReviewControls = ({ review, objectType, objectUuid, approvalBlocked = false }) => {
    if (!review.hasReviewControls) {
        return null;
    }
    return (react_1.default.createElement(ObjectReviewButtons_1.default, { objectType: objectType, objectUuid: objectUuid, status: review.status, canForceApprove: review.canForceApprove, onApprove: review.approve, onReject: review.reject, onClearReview: review.clearReview, onForceApprove: review.forceApprove, onClearForceApprove: review.clearForceApprove, onRequestReReview: review.requestReReview, approvalBlocked: approvalBlocked }));
};
exports.default = ObjectReviewControls;
//# sourceMappingURL=ObjectReviewControls.js.map